import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Moment from "moment";
import { COMPANY_NAME, PROJECT_NAME } from "../../../constants/AppInformation";
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import LayoutLogo from "./LayoutLogo"
import institutionLogo from "../../../assets/img/logo-binus-white.png";
import beelajarLogo from "../../../assets/img/beelajar.png";

import instagram from "../../../assets/img/sm-instagram.png";
import twitter from "../../../assets/img/sm-twitter.png";
import whatsapp from "../../../assets/img/sm-whatsapp.png";
import facebook from "../../../assets/img/sm-facebook.png";

import { ApiService } from "../../../constants";
import { HttpService } from "../../../utilities";
import Skeleton from 'react-loading-skeleton'

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class LayoutFooter extends Component<any, any> {
  static propTypes: {
    children: PropTypes.Requireable<PropTypes.ReactNodeLike>;
  };

  static defaultProps: {};

  constructor(props:any){ 
    super(props)
    this.state = {
      loading: false,
      data: null
    }
  }

  fetchData = () => {
    this.setState({ loading: true })
    HttpService.post(
      ApiService.icdc.module.footer.getConfig, 
      {}
    )
    .then(resp => {

      let newData = resp?.data
      this.setState({ loading: false })
      this.setState({ data: newData })

    })
  }

  componentDidMount = () => {
    this.fetchData()
  }

  render() {

    const { children, ...attributes } = this.props;

    return (
      <div className="footer">
        <Container fluid="xl">
        {
          this.state.loading ? (
            <Skeleton />
          ):(
          <Row>
            {
              this.state.data && this.state.data.footerColumns.map((column, i) => {
                return <Col xs={12} xl={4} lg={4} key={i} className="col column d-flex">
                  <div className="content full-parent-width">
                    <div className="title">{column.configDescription}</div>
                    <div className="address">
                      <div dangerouslySetInnerHTML={{__html: column.configLongDescription}} />  
                    </div>
                  </div>
                </Col>
              })
            }
          </Row>
          )
        }
        </Container>
      </div>
    );
  }
}

LayoutFooter.propTypes = propTypes;
LayoutFooter.defaultProps = defaultProps;

export default LayoutFooter;
